import OfficialDocumentDetail from '@/views/backstage/structure/detail_page/OfficialDocumentDetailStructure'
import GraphDetail from '@/views/backstage/structure/detail_page/GraphDetailStructure'
import PublicationDetail from '@/views/backstage/structure/detail_page/PublicationDetailStructure'
import ImageDetail from '@/views/backstage/structure/detail_page/ImageDetailStructure'
import CulturalRelicsDetail from '@/views/backstage/structure/detail_page/CulturalRelicsDetailStructure'
import OralHistoryDetail from '@/views/backstage/structure/detail_page/OralHistoryDetailStructure'
import CultureNaturalLandscapeDetail from '@/views/backstage/structure/detail_page/CultureNaturalLandscapeDetailStructure'
import BuildingsDetail from '@/views/backstage/structure/detail_page/BuildingsDetailStructure'
import ArticleDetailStructure from '@/views/backstage/structure/detail_page/frontstage/ArticleDetailStructure'

export default  (detail_page_type, front_back='backstage') => {
    if (typeof detail_page_type !== 'string' || typeof front_back !== 'string') {
        console.error('incorrect parameter')
        return []
    }

    switch (detail_page_type) {
    case 'official_document': return OfficialDocumentDetail(front_back);
    case 'graph': return GraphDetail(front_back);
    case 'publication': return PublicationDetail(front_back);
    case 'image': return ImageDetail(front_back);
    case 'cultural_relics': return CulturalRelicsDetail(front_back);
    case 'oral_history': return OralHistoryDetail(front_back);
    case 'culture_natural_landscape': return CultureNaturalLandscapeDetail(front_back);
    case 'buildings': return BuildingsDetail(front_back);
    case 'collection': return ArticleDetailStructure;
    default: return []
    }
}
